import { type AdProvidersSettings, AdProviderTypes, type EffectiveType } from '@/types'

const VERY_SLOW_EFFECTIVE_TYPES = ['2g', 'slow-2g']
const SLOW_EFFECTIVE_TYPES = [...VERY_SLOW_EFFECTIVE_TYPES, '3g']

export function filterAdProviderSettings(
    effectiveType: EffectiveType | undefined,
    settings: AdProvidersSettings[],
): AdProvidersSettings[] {
    const isSlowConnection = effectiveType && SLOW_EFFECTIVE_TYPES.includes(effectiveType)
    const isVerySlowConnection = effectiveType && VERY_SLOW_EFFECTIVE_TYPES.includes(effectiveType)

    if (isVerySlowConnection) {
        return []
    }

    if (isSlowConnection) {
        return settings.filter(({ type }) => type !== AdProviderTypes.GAM_INSTREAM)
    }

    return settings
}

export function filterGoogleProviders(
    isGoogleProvidersEnabled: boolean,
    providers: AdProvidersSettings[],
): AdProvidersSettings[] {
    return isGoogleProvidersEnabled
        ? providers
        : providers.filter(
              (p) =>
                  ![
                      AdProviderTypes.GAM_H5,
                      AdProviderTypes.GAM_BANNER_INTERSTITIAL,
                      AdProviderTypes.GAM_INSTREAM,
                  ].includes(p.type as AdProviderTypes),
          )
}
